

module.exports = __webpack_require__.stylable.create(
    "ErrorMessageWrapper1122160863",
    {"classes":{"root":"ErrorMessageWrapper1122160863__root","message":"ErrorMessageWrapper1122160863__message","icon":"ErrorMessageWrapper1122160863__icon","messageWithSuffix":"ErrorMessageWrapper1122160863__messageWithSuffix"},"vars":{"wut-error-color":"--wut-error-color"},"stVars":{"DefaultErrorColor":"#DF3131","DefaultMinMessageHeight":"0","ErrorColor":"--overridable","MinMessageHeight":"--overridable","errorColor":"\"color(fallback(--overridable, #DF3131))\"","fixedMinHeight":"20px","fixedMarginTop":"8px"},"keyframes":{}},
    "",
    2,
    "ErrorMessageWrapper1122160863",
    null
);
